import Router from './Router/Router';
import Toast from './Utils/ToastContainer/Toast';

function App() {
  return (
    <div className="App">
      <Router />
      <Toast/>
    </div>
  );
}

export default App;
